import React, { useState } from 'react';
import { MarketStatisticsBox } from './MarketStatisticsDetail';
import i18n from '../../../common/i18n';

function MarketStatisticsDropdown({ stats, isSelected, addPick, live }) {
    const [expanded, setExpanded] = useState(false);
    const betId = stats.get('betId');
    const selections = stats.get('selections');
    const infoNumber = stats.get('infoNumber');
    return (
        <>
            {selections.slice(0, expanded ? selections.size : 5).map(selection => (
                <MarketStatisticsBox
                    key={selection.get('selectionName')}
                    stats={selection}
                    betId={betId}
                    infoNumber={infoNumber}
                    isSelected={isSelected}
                    addPick={addPick}
                    live={live}
                />
            ))}
            <span className="nui-marketing-statistics-span" onClick={() => setExpanded(e => !e)}>
                {expanded ? i18n('nui.MS.showLess') : i18n('nui.MS.showMore')}
            </span>
        </>
    );
}
export default MarketStatisticsDropdown;
